import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { readyApartmentsChange } from '../../actions';
import { ReadyApartments as ReadyApartmentsComponent } from '../../components/ReadyApartments';
import { getReadyApartments } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';

export function ReadyApartments() {
  const dispatch: TThunkDispatch = useDispatch();
  const readyApartments = useSelector(getReadyApartments);

  const handleReadyApartmentsChange = React.useCallback(
    (event: React.SyntheticEvent, value: boolean) => {
      dispatch(readyApartmentsChange(value));
      setQueryParameter('readyApartments', value);
    },
    [dispatch],
  );

  return <ReadyApartmentsComponent readyApartments={readyApartments} onChange={handleReadyApartmentsChange} />;
}
